import RealmAccessDenied from './RealmAccessDenied';

export default RealmAccessDenied;
